import React from 'react';
import { useTranslation } from 'react-i18next';

import FilterCollection from 'components/organisms/FilterCollection';

const RtbItlTpCodeFilter = (props) => {
  const { t } = useTranslation();
  const { params, getTempParam } = props;
  return (
    <FilterCollection
      label={t('외부연동')}
      value={params.itlTpCode}
      name="itlTpCode"
      type="select"
      params={params}
      list={[
        { label: t('구글'), value: '04' },
        { label: 'AdFit', value: '05' },
        { label: 'igaworks', value: '08' },
        { label: 'NHNACE', value: '09' },
        { label: 'MIXER', value: '10' },
        { label: '네이트', value: '12' },
        { label: 'LGCNS', value: '13' },
      ]}
      labelKey="label"
      valueKey="value"
      callBack={getTempParam}
    />
  );
};

export default RtbItlTpCodeFilter;
